import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Input, Typography, Slider } from "@mui/material";
import axios from "axios";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../cropper/cropImage"

const UploadLogoDialog = ({ open, handleClose, innovationId, onLogoUpdated }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setImageSrc(reader.result);
        setSelectedFile(file);
      };
    }
  };  
  

  const handleUpload = async () => {
    if (!croppedAreaPixels || !imageSrc) {
      alert("Please select and crop an image.");
      return;
    }
  
    const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
    const formData = new FormData();
    formData.append("file", croppedImageBlob, selectedFile.name); // same filename
  
    const token = localStorage.getItem("token");
  
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/innovations/${innovationId}/upload-logo`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
  
      alert("Logo updated successfully!");
      onLogoUpdated();
      handleClose();
    } catch (error) {
      console.error("Error uploading logo:", error);
    }
  };
  

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold", backgroundColor: "#191919", color: "white" }}>
        Upload New Logo
      </DialogTitle>
      <Typography sx={{ backgroundColor: "#191919", padding: "5px 24px", color: "white" }}>Logo must be 1:1</Typography>
      <DialogContent sx={{ backgroundColor: "#191919", padding: "24px", color: "white" }}>
  {imageSrc ? (
    <>
      <div style={{ position: "relative", width: "100%", height: 300 }}>
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={1}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={(_, croppedAreaPixels) => setCroppedAreaPixels(croppedAreaPixels)}
        />
      </div>
      <div style={{ marginTop: 20, padding: "0 20px" }}>
        <Typography variant="body2" sx={{ color: "white", marginBottom: 1 }}>
          Zoom
        </Typography>
        <Slider
          value={zoom}
          min={1}
          max={3}
          step={0.1}
          onChange={(e, newZoom) => setZoom(newZoom)}
          sx={{ color: "white" }}
        />
      </div>
    </>
  ) : (
    <Input type="file" onChange={handleFileChange} fullWidth sx={{ color: "white" }} />
  )}
</DialogContent>

      <DialogActions sx={{ backgroundColor: "#191919", padding: "16px" }}>
        <Button onClick={handleClose} sx={{ color: "white", fontWeight: "bold" }}>
          Cancel
        </Button>
        <Button
          onClick={handleUpload}
          sx={{
            backgroundColor: "rgb(var(--global-color-primary))",
            color: "black",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "rgba(var(--global-color-primary), 0.8)" },
          }}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadLogoDialog;
